import * as React from 'react';
import { TDeviceType } from '@cian/ui-kit';

import { SearchModalSubmitButton } from '../../../../components/SearchModal';

export interface ISearchModalSubmitButtonContainerProps {
  deviceType: TDeviceType;
  loading?: boolean;
  onClick: () => void;
}

export const SearchModalSubmitButtonContainer: React.FC<ISearchModalSubmitButtonContainerProps> = props => {
  const { deviceType, loading, onClick } = props;
  const buttonSize = deviceType === 'phone' ? 'M' : 'XS';

  return (
    <SearchModalSubmitButton loading={loading} onClick={onClick} size={buttonSize} fullWidth={deviceType === 'phone'} />
  );
};
